import Vue from 'vue'

export default Vue.mixin({
  methods: {
    async validateForm(scope, callback) {
      if (this.$validator && await this.$validator.validateAll(scope)) {
        callback()
      }
      return false
    },
    async pushDeviceInfo(notificationsToken = null, tokenType = null) {
      this.$http.post("/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/users/devices",
          {
            notifications_token: notificationsToken,
            notifications_type: tokenType
          }
      )
    }
  }
})